import { Box, Typography, RouteOutlinedIcon, AddIcon } from 'src/components';
import StepCard from './step-card';

export default function TripDetailsSteps({ 
    isPublicPortal, 
    steps = [], 
    handleViewChange, 
    tripStartDate, 
    setSelectedStep, 
    setDrawerState,
    showPolarstepsUrl }) {

    const sortedSteps = [...steps].sort((a, b) =>
        new Date(a.startDate) - new Date(b.startDate)
    );

    const hasSteps = sortedSteps.length > 0;

    return (
        <Box sx={{
            display: 'flex',
            position: 'relative',
            alignItems: 'flex-start',
            flexDirection: 'column',
            mt: 1}}>

            {/* Header */}
            <Box 
                display="flex" 
                alignItems="center" 
                gap={1} 
                sx={{
                    height: '50px',
                    width: '100%', 
                    border: '1px solid #ccc', 
                    borderRadius: 3}}>

                <RouteOutlinedIcon sx={{ml: 2.5}}  />
                <Typography variant="body2" fontWeight={600}>
                    Trip Started: {new Date(tripStartDate).toLocaleDateString()}
                </Typography>

            </Box>

            {!hasSteps && (
                <Box sx={{width: '100%', paddingTop: 3, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    {showPolarstepsUrl ?
                        <Typography variant="body1" fontWeight={500} sx={{ mb: 1, textAlign: 'center' }}>
                            This is a Polarsteps trip so others can view it from the map!
                        </Typography>
                        : <>
                        <Typography variant="body1" fontWeight={600} sx={{ mb: 1 }}>
                            No steps added yet
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Start documenting your journey by adding your first step.
                        </Typography>
                    </>}
                </Box>
            )}

            {/* Timeline */}
            {sortedSteps.map((step, index) => (
                <StepCard 
                    key={step.id} 
                    isPublicPortal={isPublicPortal} 
                    index={index} 
                    step={step} 
                    handleViewChange={handleViewChange}
                    setSelectedStep={setSelectedStep}
                    setDrawerState={setDrawerState} />
            ))}

            {!isPublicPortal && !showPolarstepsUrl && (
                <Box
                    display="flex"
                    justifyContent= "center"
                    alignItems="center"
                    gap={1}
                    mt={2}
                    sx={{
                        width: '100%',
                        border: '2px dashed #ccc',
                        p: 2,
                        borderRadius: 2,
                        cursor: 'pointer',
                        '&:hover': { borderColor: 'primary.main' },
                    }}
                    onClick={() => handleViewChange('AddStep')}>

                        <AddIcon />
                        <Typography variant="body1" fontWeight={600}>{'Add Step'}</Typography>

                </Box>
            )}

        </Box>
    );
}
